import { gql } from '../../../apollo/__generated__';

export const UPDATE_USER = gql(`
  mutation UpdateUser($updateUserInput: UpdateUserInput!) {
    updateUser(updateUserInput: $updateUserInput) {
      id
      firstname
      lastname
      nickname
      email
      isAdmin
      isStaff
      folklore
      studyTown
      studies
      phone
      externalReferentLastname
      externalReferentFirstname
      externalReferentPhone
      birthdate
      food
      allergies
      medication
    }
  }
`);
